/**
 * @author caijianjia
 * @date 2024-05-30 20:24
 */
export default {
  home: {
    banner1: require('./home/banner1.png'),
    contact_bg: require('./home/contact_bg.png'),
    footLogo: require('./home/footLogo.png'),
    future1: require('./home/future1.png'),
    future2: require('./home/future2.png'),
    future3: require('./home/future3.png'),
    future4: require('./home/future4.png'),
    icon_email: require('./home/icon_email.png'),
    icon_fax: require('./home/icon_fax.png'),
    icon_tel: require('./home/icon_tel.png'),
    logo: require('./home/logo.png'),
    logo1: require('./home/logo1.png'),
    logoTxt: require('./home/logoTxt.png'),
    product1: require('./home/product1.png'),
    product1_1: require('./home/product1_1.png'),
    product01: require('./home/product01.png'),
    product02: require('./home/product02.png'),
    product03: require('./home/product03.png'),
    product04: require('./home/product04.jpg'),
    product05: require('./home/product05.jpg'),
    product06: require('./home/product06.png'),
    product07: require('./home/product07.jpg'),
    product_1: require('./home/product_1.png'),
    product_2: require('./home/product_2.png'),
    product_3: require('./home/product_3.png'),
    product_4: require('./home/product_4.png'),
    product_5: require('./home/product_5.png'),
    product_6: require('./home/product_6.png'),
    product_7: require('./home/product_7.png'),
    service: require('./home/service.png')
  },
  summary: {
    summaryBanner: require('./summary/banner.png')
  },
  culture: {
    cultureBanner: require('./culture/banner.png')
  },
  content: {
    contentBanner: require('./content/banner.png')
  },
  product: {
    productBanner: require('./product/banner.png')
  },
  future: {
    futureBanner: require('./future/banner.png'),
    link1: require('./future/link1.png'),
    link2: require('./future/link2.png'),
    link3: require('./future/link3.png'),
    link4: require('./future/link4.png'),
    zhuzhai1: require('./future/zhuzhai1.png'),
    zhuzhai2: require('./future/zhuzhai2.png'),
    zhuzhai3: require('./future/zhuzhai3.png'),
    cangku1: require('./future/cangku1.png'),
    cangku2: require('./future/cangku2.png'),
    cangku3: require('./future/cangku3.png'),
    cangku4: require('./future/cangku4.png'),
    cangku5: require('./future/cangku5.png')
  }
}
